import packageInfo from '../../package.json';

export const environment = {
    appVersion: packageInfo.version,
    production: false,
    apiUrl: 'https://t5wtdzvfhh.execute-api.eu-central-1.amazonaws.com/v1/',
    // apiUrl: 'http://localhost:8081/v1/',
};
